<template>
    <svg class="aurora-icon" :data-icon="name" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.7"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path v-if="paths.length" :d="paths[0]" fill="currentColor" fill-opacity=".10" stroke="none" />
        <path v-for="(item, index) in paths" :key="index" :d="item" fill="none" />
    </svg>
</template>

<script>
import { icons } from './icons'

export default {
    name: 'AuroraIcon',
    props: {
        name: { type: String, required: true }
    },
    computed: {
        paths() {
            return icons[this.name] || []
        }
    }
}
</script>

<style scoped>
.aurora-icon {
    display: inline-block;
    flex-shrink: 0;
    vertical-align: middle;
    pointer-events: none;
}
</style>
